export default __webpack_public_path__ + "static/media/caseSlide7.b09e3651.png";